import { render, staticRenderFns } from "./slModal.vue?vue&type=template&id=32bb4d82"
import script from "./slModal.vue?vue&type=script&lang=js"
export * from "./slModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports